// The customer collection protocol: one list of questions, read by the intake
// form, the profile card and the directory's protocol dialog, so the three
// can never word a question differently or drop one.

import { Pill } from './components/ui/index.js'
import { PROTOCOL_ITEMS } from '../../shared/protocol.js'

export { PROTOCOL_ITEMS } from '../../shared/protocol.js'

// The answers as read-only rows, then the customer-specific protocols text
// when there is any. Notes are not part of the protocol and never show here.
export function ProtocolRows({ customer }) {
  return (
    <div className="rows">
      {PROTOCOL_ITEMS.map((item) => {
        const value = customer[item.field]
        return (
          <div key={item.field} className="row">
            <div className="row-main">
              <div className="row-primary wraps">{item.label}</div>
            </div>
            <div className="row-trail">
              <Pill tone={value ? 'ok' : 'neutral'}>{value ? 'Yes' : 'No'}</Pill>
            </div>
          </div>
        )
      })}
      <div className="row">
        <div className="row-main">
          <div className="row-meta">Customer-specific protocols</div>
          <div className="row-primary multiline">
            {customer.customerProtocols || <span className="muted">None</span>}
          </div>
        </div>
      </div>
    </div>
  )
}
